__turbopack_context__.v({
  "Logoicon": "revoke-module__-wXyPq__Logoicon",
  "buttonrevoke": "revoke-module__-wXyPq__buttonrevoke",
  "closeButton": "revoke-module__-wXyPq__closeButton",
  "lastLogin": "revoke-module__-wXyPq__lastLogin",
  "loginDetail": "revoke-module__-wXyPq__loginDetail",
  "revokeContainer": "revoke-module__-wXyPq__revokeContainer",
  "revokeDesc": "revoke-module__-wXyPq__revokeDesc",
  "revokeList": "revoke-module__-wXyPq__revokeList",
  "revokeSec": "revoke-module__-wXyPq__revokeSec",
});
